(function() {
  'use strict';

  /* ── European Vehicle Data (2015-2024) ── */
  var vehicleData = {
    'Audi': {
      models: {
        'A3': {trims: ['Premium', 'Premium Plus', 'Prestige'], years: '2015-2024'},
        'A4': {trims: ['Premium', 'Premium Plus', 'Prestige', 'S-Line'], years: '2015-2024'},
        'A5': {trims: ['Premium', 'Premium Plus', 'Prestige'], years: '2015-2024'},
        'A6': {trims: ['Premium', 'Premium Plus', 'Prestige'], years: '2015-2024'},
        'A7': {trims: ['Premium', 'Premium Plus', 'Prestige'], years: '2016-2024'},
        'A8': {trims: ['L', 'L 60 TFSI'], years: '2015-2024'},
        'Q3': {trims: ['Premium', 'Premium Plus', 'Prestige'], years: '2015-2024'},
        'Q5': {trims: ['Premium', 'Premium Plus', 'Prestige'], years: '2015-2024'},
        'Q7': {trims: ['Premium', 'Premium Plus', 'Prestige'], years: '2015-2024'},
        'Q8': {trims: ['Premium', 'Premium Plus', 'Prestige'], years: '2019-2024'},
        'TT': {trims: ['2.0T', '2.0T S-Line'], years: '2015-2024'},
        'e-tron': {trims: ['Premium', 'Premium Plus', 'Prestige'], years: '2019-2024'},
        'S3': {trims: ['Premium Plus', 'Prestige'], years: '2015-2024'},
        'S4': {trims: ['Premium Plus', 'Prestige'], years: '2015-2024'},
        'S5': {trims: ['Premium Plus', 'Prestige'], years: '2015-2024'},
        'RS3': {trims: ['Base'], years: '2017-2024'},
        'RS5': {trims: ['Base'], years: '2018-2024'}
      },
      collection: 'audi-parts'
    },
    'BMW': {
      models: {
        '2 Series': {trims: ['228i', '230i', 'M235i', 'M240i'], years: '2015-2024'},
        '3 Series': {trims: ['320i', '328i', '330i', '330e', '340i', 'M340i'], years: '2015-2024'},
        '4 Series': {trims: ['428i', '430i', '435i', '440i', 'M440i'], years: '2015-2024'},
        '5 Series': {trims: ['528i', '530i', '535i', '540i', 'M550i'], years: '2015-2024'},
        '7 Series': {trims: ['740i', '750i', '760i'], years: '2015-2024'},
        'X1': {trims: ['sDrive28i', 'xDrive28i'], years: '2015-2024'},
        'X2': {trims: ['sDrive28i', 'xDrive28i'], years: '2018-2024'},
        'X3': {trims: ['sDrive30i', 'xDrive30i', 'M40i'], years: '2015-2024'},
        'X4': {trims: ['xDrive30i', 'M40i'], years: '2015-2024'},
        'X5': {trims: ['sDrive40i', 'xDrive40i', 'xDrive50i', 'M50i'], years: '2015-2024'},
        'X6': {trims: ['xDrive35i', 'xDrive50i', 'M50i'], years: '2015-2024'},
        'X7': {trims: ['xDrive40i', 'xDrive50i'], years: '2019-2024'},
        'Z4': {trims: ['sDrive30i', 'M40i'], years: '2019-2024'},
        'M3': {trims: ['Base', 'Competition'], years: '2015-2024'},
        'M4': {trims: ['Base', 'Competition'], years: '2015-2024'},
        'M5': {trims: ['Base', 'Competition'], years: '2015-2024'},
        'i3': {trims: ['Base', 'Range Extender'], years: '2015-2021'},
        'i4': {trims: ['eDrive40', 'M50'], years: '2022-2024'},
        'iX': {trims: ['xDrive50', 'M60'], years: '2022-2024'}
      },
      collection: 'bmw-parts'
    },
    'Mercedes-Benz': {
      models: {
        'A-Class': {trims: ['A 220', 'A 250', 'AMG A 35'], years: '2019-2024'},
        'C-Class': {trims: ['C 300', 'C 43 AMG', 'C 63 AMG'], years: '2015-2024'},
        'E-Class': {trims: ['E 350', 'E 450', 'E 53 AMG', 'E 63 AMG'], years: '2015-2024'},
        'S-Class': {trims: ['S 500', 'S 580', 'S 63 AMG'], years: '2015-2024'},
        'CLA': {trims: ['CLA 250', 'AMG CLA 35', 'AMG CLA 45'], years: '2015-2024'},
        'CLS': {trims: ['CLS 450', 'AMG CLS 53'], years: '2015-2024'},
        'GLA': {trims: ['GLA 250', 'AMG GLA 35', 'AMG GLA 45'], years: '2015-2024'},
        'GLB': {trims: ['GLB 250', 'AMG GLB 35'], years: '2020-2024'},
        'GLC': {trims: ['GLC 300', 'AMG GLC 43', 'AMG GLC 63'], years: '2016-2024'},
        'GLE': {trims: ['GLE 350', 'GLE 450', 'AMG GLE 53', 'AMG GLE 63'], years: '2016-2024'},
        'GLS': {trims: ['GLS 450', 'GLS 580', 'AMG GLS 63'], years: '2017-2024'},
        'G-Class': {trims: ['G 550', 'AMG G 63'], years: '2015-2024'},
        'SL': {trims: ['SL 55 AMG', 'SL 63 AMG'], years: '2022-2024'},
        'EQB': {trims: ['EQB 250+', 'EQB 300', 'EQB 350'], years: '2022-2024'},
        'EQS': {trims: ['EQS 450+', 'EQS 580', 'AMG EQS'], years: '2022-2024'}
      },
      collection: 'mercedes-benz-parts'
    },
    'Volkswagen': {
      models: {
        'Golf': {trims: ['S', 'SE', 'SEL', 'R', 'GTI S', 'GTI SE', 'GTI Autobahn'], years: '2015-2024'},
        'Jetta': {trims: ['S', 'SE', 'SEL', 'SEL Premium', 'GLI S', 'GLI Autobahn'], years: '2015-2024'},
        'Passat': {trims: ['S', 'SE', 'SEL', 'SEL Premium'], years: '2015-2022'},
        'Tiguan': {trims: ['S', 'SE', 'SEL', 'SEL R-Line'], years: '2015-2024'},
        'Atlas': {trims: ['S', 'SE', 'SEL', 'SEL Premium'], years: '2018-2024'},
        'Atlas Cross Sport': {trims: ['S', 'SE', 'SEL', 'SEL Premium'], years: '2020-2024'},
        'Taos': {trims: ['S', 'SE', 'SEL'], years: '2022-2024'},
        'Arteon': {trims: ['SE', 'SEL Premium', 'SEL R-Line'], years: '2019-2024'},
        'ID.4': {trims: ['Standard', 'Pro', 'Pro S', 'AWD Pro S Plus'], years: '2021-2024'},
        'GTI': {trims: ['S', 'SE', 'Autobahn'], years: '2015-2024'},
        'Golf R': {trims: ['Base'], years: '2015-2024'}
      },
      collection: 'volkswagen-parts'
    },
    'Porsche': {
      models: {
        '911': {trims: ['Carrera', 'Carrera S', 'Carrera 4S', 'Turbo', 'Turbo S', 'GT3'], years: '2015-2024'},
        'Cayenne': {trims: ['Base', 'S', 'GTS', 'Turbo', 'Turbo GT'], years: '2015-2024'},
        'Macan': {trims: ['Base', 'S', 'GTS', 'Turbo'], years: '2015-2024'},
        'Panamera': {trims: ['Base', '4', '4S', 'GTS', 'Turbo', 'Turbo S'], years: '2015-2024'},
        'Taycan': {trims: ['Base', '4S', 'GTS', 'Turbo', 'Turbo S'], years: '2020-2024'},
        '718 Boxster': {trims: ['Base', 'S', 'GTS', 'Spyder'], years: '2017-2024'},
        '718 Cayman': {trims: ['Base', 'S', 'GTS', 'GT4'], years: '2017-2024'}
      },
      collection: 'porsche-parts'
    },
    'MINI': {
      models: {
        'Cooper': {trims: ['Base', 'S', 'JCW'], years: '2015-2024'},
        'Cooper Clubman': {trims: ['Base', 'S', 'JCW'], years: '2016-2024'},
        'Cooper Countryman': {trims: ['Base', 'S', 'SE', 'JCW'], years: '2015-2024'},
        'Cooper Convertible': {trims: ['Base', 'S', 'JCW'], years: '2016-2024'}
      },
      collection: 'mini-parts'
    },
    'Volvo': {
      models: {
        'S60': {trims: ['Momentum', 'R-Design', 'Inscription', 'Polestar'], years: '2015-2024'},
        'S90': {trims: ['Momentum', 'R-Design', 'Inscription'], years: '2017-2024'},
        'V60': {trims: ['Momentum', 'R-Design', 'Inscription', 'Cross Country'], years: '2015-2024'},
        'V90': {trims: ['Cross Country'], years: '2017-2024'},
        'XC40': {trims: ['Momentum', 'R-Design', 'Inscription', 'Recharge'], years: '2019-2024'},
        'XC60': {trims: ['Momentum', 'R-Design', 'Inscription', 'Polestar'], years: '2015-2024'},
        'XC90': {trims: ['Momentum', 'R-Design', 'Inscription', 'Excellence'], years: '2015-2024'},
        'C40 Recharge': {trims: ['Core', 'Plus', 'Ultimate'], years: '2022-2024'}
      },
      collection: 'volvo-parts'
    }
  };

  function init() {
    var yearEl = document.getElementById('vehicle-year');
    var makeEl = document.getElementById('vehicle-make');
    var modelEl = document.getElementById('vehicle-model');
    var trimEl = document.getElementById('vehicle-trim');
    var goBtn = document.getElementById('vehicle-go-btn');
    var vinInlineInput = document.getElementById('vin-input-inline');
    var vinInlineBtn = document.getElementById('vin-search-btn-inline');

    if (!yearEl || !makeEl) return;

    /* ── Populate Year dropdown (2024 down to 2000) ── */
    if (yearEl.options.length <= 1) {
      for (var y = 2024; y >= 2000; y--) {
        var opt = document.createElement('option');
        opt.value = y;
        opt.textContent = y;
        yearEl.appendChild(opt);
      }
    }


    /* ── Year change => populate Makes ── */
    yearEl.addEventListener('change', function() {
      var selectedYear = parseInt(yearEl.value);
      makeEl.innerHTML = '<option value="">Make</option>';
      modelEl.innerHTML = '<option value="">Model</option>';
      trimEl.innerHTML = '<option value="">Trim</option>';
      if (!selectedYear) return;
      var makes = Object.keys(vehicleData).sort();
      makes.forEach(function(make) {
        var opt = document.createElement('option');
        opt.value = make;
        opt.textContent = make;
        makeEl.appendChild(opt);
      });
    });

    /* ── Make change => populate Models ── */
    makeEl.addEventListener('change', function() {
      var selectedYear = parseInt(yearEl.value);
      var selectedMake = makeEl.value;
      modelEl.innerHTML = '<option value="">Model</option>';
      trimEl.innerHTML = '<option value="">Trim</option>';
      if (!selectedMake || !vehicleData[selectedMake]) return;
      var models = Object.keys(vehicleData[selectedMake].models).sort();
      models.forEach(function(model) {
        var info = vehicleData[selectedMake].models[model];
        var range = info.years.split('-');
        var minY = parseInt(range[0]), maxY = parseInt(range[1]);
        if (selectedYear >= minY && selectedYear <= maxY) {
          var opt = document.createElement('option');
          opt.value = model;
          opt.textContent = model;
          modelEl.appendChild(opt);
        }
      });
    });

    /* ── Model change => populate Trims ── */
    modelEl.addEventListener('change', function() {
      var selectedMake = makeEl.value;
      var selectedModel = modelEl.value;
      trimEl.innerHTML = '<option value="">Trim</option>';
      if (!selectedMake || !selectedModel) return;
      var modelData = vehicleData[selectedMake].models[selectedModel];
      if (!modelData) return;
      modelData.trims.forEach(function(trim) {
        var opt = document.createElement('option');
        opt.value = trim;
        opt.textContent = trim;
        trimEl.appendChild(opt);
      });
    });

    /* ── GO button => search/navigate ── */
    goBtn.addEventListener('click', function() {
      var make = makeEl.value;
      var model = modelEl.value;
      if (!make) { alert('Please select a Make'); return; }
      var collection = vehicleData[make] ? vehicleData[make].collection : '';
      if (collection) {
        if (model) {
          window.location.href = '/collections/' + collection + '?q=' + encodeURIComponent(model);
        } else {
          window.location.href = '/collections/' + collection;
        }
      } else {
        window.location.href = '/search?q=' + encodeURIComponent(make + (model ? ' ' + model : ''));
      }
    });

    /* ── Inline VIN search ── */
    if (vinInlineInput && vinInlineBtn) {
      vinInlineInput.addEventListener('input', function() {
        this.value = this.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');
      });
      vinInlineBtn.addEventListener('click', function() {
        var vin = vinInlineInput.value.trim();
        if (vin.length !== 17) {
          alert('Please enter a valid 17-character VIN');
          return;
        }
        /* Scroll to VIN search section if it exists, or decode inline */
        var vinSection = document.getElementById('vin-input');
        if (vinSection) {
          vinSection.value = vin;
          vinSection.scrollIntoView({behavior: 'smooth', block: 'center'});
          setTimeout(function() {
            var mainBtn = document.getElementById('vin-search-btn');
            if (mainBtn) mainBtn.click();
          }, 500);
        } else {
          /* Decode directly using NHTSA API */
          fetch('https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvalues/' + vin + '?format=json')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var v = data.Results[0];
              var make = v.Make || 'Unknown';
              var model = v.Model || '';
              window.location.href = '/search?q=' + encodeURIComponent(make + ' ' + model);
            })
            .catch(function() {
              alert('Could not decode VIN. Please try the VIN search below.');
            });
        }
      });
      vinInlineInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') vinInlineBtn.click();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();